import { render, staticRenderFns } from "./ResetUserPasswordDialog.vue?vue&type=template&id=3f4c3a7d&"
import script from "./ResetUserPasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./ResetUserPasswordDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports